var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavAndBody',[_c('h1',{staticClass:"page-title"},[_vm._v("작품 리스트")]),_c('ArtListFilter'),_c('ArtList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }